module.exports = __webpack_public_path__ + "img/brands-wasa-co2.jpg?d47d83649fe5dda9f90dfba821ea4ef2";